import { render } from "./ComplainsPage.vue?vue&type=template&id=ecc10f84&scoped=true"
import script from "./ComplainsPage.vue?vue&type=script&lang=js"
export * from "./ComplainsPage.vue?vue&type=script&lang=js"

import "./ComplainsPage.vue?vue&type=style&index=0&id=ecc10f84&scoped=true&lang=css"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecc10f84"]])

export default __exports__